import React, { useState } from 'react'
import UploadFile from './uploadFile'
import { Button, ButtonGroup, Backdrop, CircularProgress } from '@material-ui/core'
import { Container, Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'

const Planning = () => {
    const [state, setState] = useState({
        Path: 'recepcionCarga',
        key: 1,
        titulo: 'Modulos recepción de carga',
        cliente: '',
        tipoOperacion: '' // 'recepcion' o 'informacion'
    })
    const { user: currentUser } = useSelector(state => state.auth)
    const [loading, setLoading] = useState(false)

    return (
        <Container fluid className="g-0 w-100">
            <Backdrop sx={{ color: '#fff' }} style={{ zIndex: 999 }} open={loading}>
                <CircularProgress />
            </Backdrop>
            <Row className="pt-5 gx-0 text-center">
                <h3>{state.titulo}</h3>
            </Row>
            <Row className="text-center gx-0" style={{ height: 'calc(100vh - 200px' }}>
                <Col xs={2} className="text-center align-self-center spread-font">
                    <ButtonGroup
                        orientation="vertical"
                        aria-label="vertical contained primary button group"
                        className="mx-2">
                        <h6>Recepción de carga</h6>
                        <Button
                            color="primary"
                            variant="contained"
                            style={{ backgroundColor: 'rgb(33, 195, 219)', marginBottom: 5 }}
                            onClick={() => {
                                setState({
                                    Path: 'recepcionShipit',
                                    key: state.key + 1,
                                    titulo: 'Recepción Shipit',
                                    cliente: 'Shipit',
                                    tipoOperacion: 'recepcion'
                                })
                            }}>
                            Recepción Shipit
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            style={{ backgroundColor: 'rgb(0, 153, 150)', marginBottom: 5 }}
                            onClick={() => {
                                setState({
                                    Path: 'recepcionKarri',
                                    key: state.key + 1,
                                    titulo: 'Recepción Karri',
                                    cliente: 'Karri',
                                    tipoOperacion: 'recepcion'
                                })
                            }}>
                            Recepción Karri
                        </Button>
                        {/* <Button
                            color="primary"
                            variant="contained"
                            style={{ backgroundColor: 'rgb(123, 5, 126)', marginBottom: 5 }}
                            onClick={() => {
                                setState({
                                    Path: 'recepcionLlego',
                                    key: state.key + 1,
                                    titulo: 'Recepción Llego',
                                    cliente: 'Llego',
                                    tipoOperacion: 'recepcion'
                                })
                            }}>
                            Recepción Llego
                        </Button> */}
                         <Button
                            color="primary"
                            variant="contained"
                            style={{ backgroundColor: 'rgb(83, 49, 120)', marginBottom: 5 }}
                            onClick={() => {
                                setState({
                                    Path: 'recepcionRipley',
                                    key: state.key + 1,
                                    titulo: 'Recepción Ripley',
                                    cliente: 'Ripley',
                                    tipoOperacion: 'recepcion'
                                })
                            }}>
                            Recepción Ripley
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            style={{ backgroundColor: 'rgb(2, 109, 255)', marginBottom: 5 }}
                            onClick={() => {
                                setState({
                                    Path: 'recepcionParis',
                                    key: state.key + 1,
                                    titulo: 'Recepción Paris',
                                    cliente: 'Paris',
                                    tipoOperacion: 'recepcion'
                                })
                            }}>
                            Recepción Paris
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            style={{ backgroundColor: 'rgb(0, 125, 198)', marginBottom: 5 }}
                            onClick={() => {
                                setState({
                                    Path: 'recepcionWalmart',
                                    key: state.key + 1,
                                    titulo: 'Recepción Walmart',
                                    cliente: 'Walmart',
                                    tipoOperacion: 'recepcion'
                                })
                            }}>
                            Recepción Walmart
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            style={{ backgroundColor: 'rgba(209, 224, 0, 1)', marginBottom: 5 }}
                            onClick={() => {
                                setState({
                                    Path: 'recepcionDimeiggs',
                                    key: state.key + 1,
                                    titulo: 'Recepción Dimeiggs',
                                    cliente: 'Dimeiggs',
                                    tipoOperacion: 'recepcion'
                                })
                            }}>
                            Recepción Dimeiggs
                        </Button>

                        <hr />
                        <h6>Cargar información de clientes</h6>
                        {/* <Button
                            color="primary"
                            variant="contained"
                            style={{ backgroundColor: 'rgb(0, 155, 26)', marginBottom: 5 }}
                            onClick={() => {
                                setState({
                                    Path: 'cargaLlego',
                                    key: state.key + 1,
                                    titulo: 'Cargar informacion Llego',
                                    cliente: 'Llego',
                                    tipoOperacion: 'informacion'
                                })
                            }}>
                            Información Llego
                        </Button> */}
                        <Button
                            key="button2"
                            color="primary"
                            variant="contained"
                            style={{ backgroundColor: 'rgb(0, 153, 150)', marginBottom: 5 }}
                            onClick={() => {
                                setState({
                                    Path: 'faltantesKarri',
                                    key: state.key + 1,
                                    titulo: 'Faltantes Karri',
                                    cliente: 'Karri',
                                    tipoOperacion: 'informacion'
                                })
                            }}>
                            Faltantes Karri
                        </Button>
                        <Button
                            key="button2"
                            color="primary"
                            variant="contained"
                            style={{ backgroundColor: 'rgb(83, 49, 120)', marginBottom: 5 }}
                            onClick={() => {
                                setState({
                                    Path: 'faltantesRipley',
                                    key: state.key + 1,
                                    titulo: 'Faltantes Ripley',
                                    cliente: 'Ripley',
                                    tipoOperacion: 'informacion'
                                })
                            }}>
                            Información Ripley
                        </Button>
                        {currentUser.email === 'eduardo@spread.cl' && (
                            <>
                                <hr key="hr1" />
                                <Button
                                    key="button1"
                                    color="primary"
                                    variant="contained"
                                    style={{ backgroundColor: 'rgb(0, 155, 120)', marginBottom: 5 }}
                                    onClick={() => {
                                        setState({
                                            Path: 'recepcionPruebas',
                                            key: state.key + 1,
                                            titulo: 'Recepción Pruebas',
                                            cliente: 'Pruebas',
                                            tipoOperacion: 'recepcion'
                                        })
                                    }}>
                                    Recepción Prueba
                                </Button>
                            </>
                        )}
                    </ButtonGroup>
                </Col>
                <UploadFile
                    path={state.Path}
                    titulo={state.titulo}
                    client={state.cliente}
                    tipoOperacion={state.tipoOperacion}
                    loading={loading}
                    setLoading={setLoading}
                />
            </Row>
        </Container>
    )
}

export default Planning
